import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const Exhibition = {
  id: '68',
  name: "Exhibition",
  width: 4,
  height: 4,
  type: BuildingType.EVENT,
  era: 'stoneAge',
  icon: 'Exhibition',
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Exhibition',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerLevel([
        1.70, 1.70, 1.70, 2.10, 2.10, 2.50, 2.50, 2.90, 2.90, 2.90,
        3.20, 3.20, 3.20, 3.50, 3.50, 3.62, 2.62, 4.05, 4.05, 4.05,
        4.45, 4.45, 4.45, 4.75, 4.75, 4.90, 4.90, 5.25, 5.25, 5.25,
        5.60, 5.60, 5.60, 5.70, 5.70, 6.05, 6.05, 6.60, 6.60, 6.95,
        7.00, 7.00, 7.00, 7.00, 7.00, 8.00, 8.00, 8.00, 8.00, 8.00,
        8.00, 8.00, 9.00, 9.00, 9.00, 9.00, 9.00, 9.00, 9.00, 10.00
      ]).withOutput(ProductionOutputType.RESEARCH_POINTS),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput
        .asFlat(1)
        .withOutput(ProductionOutputType.CHEST)
        .withDescription('Produce chest which can include goods, coins or Negotiation Joker')
      ,
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          0,0,35,35,35,35,50,50,50,70,70,70,85,85,85,85,100,100,100,110,110,110,120,120,120,120,125,125,125,135,135,135,145,145,145,145,155,158,160,163,165,168,170,173,175,178,180,183,185,188,190,193,195,198,200,203,205,208,210,213
        ],
        bronzeAge: [
          0,0,35,35,35,35,50,50,50,70,70,70,85,85,85,85,100,100,100,110,110,110,120,120,120,120,125,125,125,135,135,135,145,145,145,145,155,158,160,163,165,168,170,173,175,178,180,183,185,188,190,193,195,198,200,203,205,208,210,213
        ],
        minoanEra: [
          0,0,45,45,45,45,65,65,65,85,85,85,105,105,105,105,125,125,125,135,135,135,150,150,150,150,155,155,155,170,170,170,185,185,185,185,200,205,209,213,216,220,224,228,232,235,239,243,247,251,254,258,262,266,270,273,277,281,285,289
        ],
        classicGreece: [
          0,0,60,60,60,60,80,80,80,105,105,105,130,130,130,130,155,155,155,170,170,170,190,190,190,190,195,195,195,215,215,215,230,230,230,230,240,245,249,253,256,260,264,268,272,275,279,283,287,291,294,298,302,306,310,313,317,321,325,329
        ],
        earlyRome: [
          0,0,70,70,70,70,95,95,95,125,125,125,150,150,150,150,180,180,180,200,200,200,220,220,220,220,230,230,230,250,250,250,265,265,265,265,290,298,304,311,317,323,329,336,342,348,355,361,367,374,380,386,392,399,405,411,418,424,430,437
        ],
        romanEmpire: [
          0,0,75,75,75,75,105,105,105,140,140,140,170,170,170,170,200,200,200,225,225,225,245,245,245,245,255,255,255,280,280,280,300,300,300,300,335,345,354,363,371,380,389,398,407,415,424,433,442,451,459,468,477,486,495,503,512,521,530,539
        ],
        byzantineEra: [
          0,0,75,75,75,75,105,105,105,140,140,140,170,170,170,170,200,200,200,225,225,225,245,245,245,245,255,255,255,280,280,280,300,300,300,300,335,345,354,363,371,380,389,398,407,415,424,433,442,451,459,468,477,486,495,503,512,521,530,539
        ],
        ageOfTheFranks: [
          0,0,75,75,75,75,105,105,105,140,140,140,170,170,170,170,200,200,200,225,225,225,245,245,245,245,255,255,255,280,280,280,300,300,300,300,335,345,354,363,371,380,389,398,407,415,424,433,442,451,459,468,477,486,495,503,512,521,530,539
        ],
        feudalAge: [
          0,0,75,75,75,75,105,105,105,140,140,140,170,170,170,170,200,200,200,225,225,225,245,245,245,245,255,255,255,280,280,280,300,300,300,300,335,345,354,363,371,380,389,398,407,415,424,433,442,451,459,468,477,486,495,503,512,521,530,539
        ],
        iberianEra: [
          0,0,75,75,75,75,105,105,105,140,140,140,170,170,170,170,200,200,200,225,225,225,245,245,245,245,255,255,255,280,280,280,300,300,300,300,335,345,354,363,371,380,389,398,407,415,424,433,442,451,459,468,477,486,495,503,512,521,530,539
        ],
        kingdomOfSicily: [
          0,0,75,75,75,75,105,105,105,140,140,140,170,170,170,170,200,200,200,225,225,225,245,245,245,245,255,255,255,280,280,280,300,300,300,300,335,345,354,363,371,380,389,398,407,415,424,433,442,451,459,468,477,486,495,503,512,521,530,539
        ],
        highMiddleAges: [
          0,0,75,75,75,75,105,105,105,140,140,140,170,170,170,170,200,200,200,225,225,225,245,245,245,245,255,255,255,280,280,280,300,300,300,300,335,345,354,363,371,380,389,398,407,415,424,433,442,451,459,468,477,486,495,503,512,521,530,539
        ],
        earlyGothicEra: [
          0,0,75,75,75,75,105,105,105,140,140,140,170,170,170,170,200,200,200,225,225,225,245,245,245,245,255,255,255,280,280,280,300,300,300,300,335,345,354,363,371,380,389,398,407,415,424,433,442,451,459,468,477,486,495,503,512,521,530,539
        ],
        lateGothicEra: [
          0,0,75,75,75,75,105,105,105,140,140,140,170,170,170,170,200,200,200,225,225,225,245,245,245,245,255,255,255,280,280,280,300,300,300,300,335,345,354,363,371,380,389,398,407,415,424,433,442,451,459,468,477,486,495,503,512,521,530,539
        ]
      }).withOutput(ProductionOutputType.ALL_CURRENT_ERA_GOODS),
    ),
  ]),
};

export default Exhibition;
